<router-outlet></router-outlet>
<ngx-spinner size="medium" type="ball-scale-multiple">
  <div class="spinner-border text-primary"></div>
</ngx-spinner>
